import { put, takeLatest, call, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import checkoutAPI from '../../api/checkout';
import customerAPI from '../../api/customer';
import { Creators as CartCreators } from '../../reducers/cart';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import getState from '../../utils/getState';

function* confirmation({ cartId }) {
  try {
    const { app, customer } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);

    const { id, token } = customer;

    const plataform = app.getIn(['plataform']);

    const size = plataform === 'mobile' ? 230 : 350;

    const queryParams = {
      media: 'SVG',
      width: size,
      height: size,
    };

    const cart = yield cartAPI.getCart(cartId, token, siteId);

    if (!id || !cartId || !token) {
      throw '/carrinho';
    }

    if (!cart || (cart.customer.id || '').toString() !== id) {
      throw '/';
    }

    yield put(CartCreators.cartSuccess(cart));

    const confirmationApi = yield call(checkoutAPI.verifyCartIsFinalized.get, cartId, token, siteId);

    if (isEmpty(confirmationApi)) {
      throw '/';
    }

    for (const seller of confirmationApi.sellers) {
      const orderInfos = yield call(customerAPI.orderInformations, seller.hash, 'load', token, siteId);

      const {
        pagamentos: { formasPagamento },
      } = orderInfos;

      const dp = formasPagamento.find((elm) => elm.formaPagamento === 'DP');
      const px = formasPagamento.find((elm) => elm.formaPagamento === 'PX');

      seller.payments = seller.pagamentos;
      Object.entries(orderInfos).forEach(([key, value]) => {
        seller[key] = value;
      });

      if (dp) {
        seller.depositAccounts = yield call(checkoutAPI.depositAccounts, dp.empresa?.id, token, siteId);
      }

      if (px) {
        const sellerId = seller.seller.id;

        try {
          const pixPayment = yield call(checkoutAPI.pixPayment, seller.hash, token, siteId, queryParams);
          yield put(CheckoutCreators.pixPaymentSuccess(sellerId, pixPayment));
        } catch (error) {
          yield put(CheckoutCreators.pixPaymentError(sellerId, error));
        }
      }
    }

    yield put(CheckoutCreators.confirmationSuccess(confirmationApi));
  } catch (error) {
    yield put(CheckoutCreators.confirmationError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CONFIRMATION_REQUEST, confirmation);
}
